export const MODEL_TYPES = {
  cfm: {
    typeName: 'cfm',
    label: 'Consolidated CF Model',
    default: true,
  },
  clm: {
    typeName: 'clm',
    label: 'Consolidated Live Model',
  },
};

export const DEFAULT_MODEL_TYPE = Object.values(MODEL_TYPES).find((m) => m.default)?.typeName;

export const DEFAULT_TEMPLATE_TYPE = 'DEFAULT';
